import { Inject, Injectable } from '@angular/core'
import {
    ConcernedControllerService,
    ConcernedDetailsMsg,
    ConcernedSubjectFullDto,
} from '../../../api/backend'
import { AuthContextStorageService } from '../../../core/auth/auth-context-storage.service'
import { BehaviorSubject, Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable({
    providedIn: 'root'
})
export class ConcernedService {

    private readonly allConcernedSource = new BehaviorSubject<ConcernedSubjectFullDto[]>([])

    constructor(@Inject(ConcernedControllerService) private concernedControllerService: ConcernedControllerService,
                @Inject(AuthContextStorageService) private authContextStorageService: AuthContextStorageService,
                ) {
    }

    fetchAllConcerned(): Observable<ConcernedSubjectFullDto[]> {
        return this.concernedControllerService.getAllConcerned(
            this.authContextStorageService.getProjectKey(),
            true
        ).pipe(
            map(data => {
                const concerned = data.items.filter(c => c.lpisUserId || c.opsubId > 0)
                this.allConcernedSource.next(concerned)
                return concerned
            })
        )
    }

    getAllConcerned(): ConcernedSubjectFullDto[] {
        return this.allConcernedSource.getValue()
    }

    getConcernedDetails(): Observable<ConcernedDetailsMsg> {
        return this.concernedControllerService.getConcernedDetails(
            this.authContextStorageService.getProjectKey(),
        )
    }
}